import { Component, OnInit } from '@angular/core';
import { ICustomLogEvents } from 'src/app/interfaces/customLogEvents';
import { LoggingService } from 'src/app/services/logging.service';

@Component({
    selector: 'app-no-report-found',
    templateUrl: './no-report-found.component.html',
    styleUrls: ['./no-report-found.component.scss'],
    standalone: false
})
export class NoReportFoundComponent implements OnInit {
  customLog!: ICustomLogEvents;
  customEvent: string = 'User Authentication - Web';
  resetPasswordDetails: any = '/no-report-found';

  constructor(private loggingService: LoggingService) {
  }

  ngOnInit() {
    this.customLog = this.loggingService.createCustomLog('Component Loading', 'no-report-found', 'INFO', this.resetPasswordDetails, '/api/no-report-found', 'get', {});
    this.loggingService.trackEvent(this.customEvent, 'Read', this.customLog);
  }
  reloadPage() {
    window.location.reload();
  }
}


